import _, { toString, isString } from 'lodash';

export const getFilterOptions = (data, selector) => {
  if (!data || !data.length) {
    return [];
  }

  return _.chain(data)
    .flatMap(selector)
    .uniq()
    .filter(x => x)
    .sortBy()
    .map(x => ({
      text: x,
      value: x
    }))
    .value();
};

export const sortAssignedRows = (key, a, b) => {
  //only unassigned license rows have string keys
  if (isString(key)) {
    return;
  }

  return toString(a).localeCompare(toString(b));
};
